<template>
  <div style="padding-left: 20px">
    <p><h3>{{ $t("pages.Auth.Unauthorized.title") }}</h3></p>
    <p>{{ $t("pages.Auth.Unauthorized.body") }}</p>
  </div>
</template>
<script>
export default {
  
created() {  
  this.$store.commit("SET_showHeader", false);
}

}
</script>